export default __webpack_public_path__ + "static/media/12.af32440b.jpg";